import { HttpClient } from '../HttpClient';
/**
 * * Get Credit Computation
 **/

export const GetCreditComputation = async () => {
  try {
    const response = await HttpClient.get(
      '/api/instawage/Advances/me/credit/computation'
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
